import { Anchor, Box, Container, Group, Text } from "@mantine/core";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, Outlet } from "react-router-dom";
import { authFirebase } from "../../config";

const Layout = () => {
    const year = new Date().getFullYear();
    const [user] = useAuthState(authFirebase);
    
    return (
        <>
            <Outlet />
            <Box component="footer" pb="xl" px="md">
                <Container size="lg">
                    <Box pt="lg" style={{ borderTop: "1px solid rgba(40, 60, 99, 0.12)" }}>
                        <Group justify="center" gap="sm" className="small-text">
                            {!user && (
                                <Anchor component={Link} to="/login" underline="hover" c="var(--my-dark)">
                                    Admin Login
                                </Anchor>
                            )}
                            {user && (
                                <Anchor component={Link} to="/dashboard" underline="hover" c="var(--my-dark)">
                                    Dashboard
                                </Anchor>
                            )}
                            <Anchor component={Link} to="/" underline="hover" c="var(--my-dark)">
                                General Clinic
                            </Anchor>
                            <Anchor component={Link} to="/behavioral-health" underline="hover" c="var(--my-dark)">
                                Behavioral Health
                            </Anchor>
                            <Anchor component={Link} to="/app-information" underline="hover" c="var(--my-dark)">
                                App Information
                            </Anchor>
                        </Group>
                        <Text ta="center" c="var(--my-dark)" size="xs" mt="xs">
                            Copyright {year} St. Mina Clinic. All rights reserved.
                        </Text>
                    </Box>
                </Container>
            </Box>
        </>
    )
};

export default Layout;
